// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__fCFUJ","label":"styles_label__NAEdL","caption":"styles_caption__x7rDg","description":"styles_description__SFGtV","content":"styles_content__7zAdA"};